import Class from './c-chart-tree-map-view';
import './c-chart-tree-map-view@.vue';

export default Class;